import { Button } from 'ui/atoms/Button/Button';
import { Section } from 'ui/molecules/Section/Section';

import styles from './DataLicensing.module.scss';

const LICENSING_AUDIENCES = [
  {
    title: 'Software and platforms',
    text: 'Embedding company records in a product your customers use.',
  },
  {
    title: 'Data providers and distributors',
    text: 'Delivering our records onward under your brand or with attribution.',
  },
  {
    title: 'AI and agent builders',
    text: 'Grounding a product on data you are licensed to show and cite.',
  },
];

export const DataLicensing = () => (
  <Section
    layout="split"
    title="Building a product on company data?"
    description="A licence is a different agreement from a subscription. It covers redistribution and white-label rights, raw delivery, and a defined territory and term — so the data can sit inside something you sell, not just a screen your staff read."
    actions={
      <Button
        type="blue"
        size="lg"
        suffixIcon="arrow-7"
        href="https://www.globaldatabase.com/data-licensing-redistribution"
      >
        Read the licensing terms
      </Button>
    }
    background="radial-gradient(1100px 560px at 100% -10%, rgba(12, 51, 207, 0.08), transparent 60%),
      radial-gradient(900px 480px at -10% 110%, rgba(56, 66, 205, 0.07), transparent 60%),
      linear-gradient(180deg, #f8fafd 0%, #eef3fb 100%)"
    className={styles.section}
  >
    <div className={styles.card}>
      {LICENSING_AUDIENCES.map((item, index) => (
        <div className={styles.audience} key={item.title}>
          <span className={styles.audienceNumber}>{String(index + 1).padStart(2, '0')}</span>

          <div className={styles.audienceBody}>
            <h3 className={styles.audienceTitle}>{item.title}</h3>
            <p className={styles.audienceText}>{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  </Section>
);
